/* PO cart drawer — behaviour. Config comes from #pocd-config (emitted by
   sections/po-cart-drawer.liquid). Subscription upsell converts lines in place via
   /cart/change.js {selling_plan: id | null}; plan ids/discounts are discovered from
   /products/<handle>.js so no plan id is hardcoded. */
(function(){
  if (window.__POCD_INIT) return; window.__POCD_INIT = true;

  var DEF = {
    strip_upsell: 'You can get up to <b>{pct} OFF</b> today <b>with subscription</b>',
    strip_saving: '🎉 <b>Congrats!</b> You\'re saving <b>{pct} OFF</b> on your first subscription',
    tag: 'GET {pct} OFF TODAY',
    /* Blank = derive {pct} from the selling plan, which is the refill discount.
       Set it (e.g. 50%) to publish ONE offer number across the whole funnel —
       listicle, PDP, drawer strip and the gold-button tag all print this figure.
       The first order is worth more than the plan discount alone because the
       Welcome Kit gifts ride along, which is why the plan % understates it.
       The refill perk is deliberately left on the real plan number. */
    strip_pct: '',
    primary_sub: 'Save with Subscription',
    primary_co: 'Proceed to Checkout',
    guarantee: '30-Day Satisfaction Guarantee',
    secondary: 'Continue with One-Time',
    switch_: 'Switch to one-time purchase ({price})',
    sub_line_sub: 'Delivery {freq}',
    sub_line_one: 'One-time purchase',
    gift_line: 'Free with your subscription',
    elig: 'Subscribe &amp; Save Eligible',
    line_switch: 'Switch &amp; get {pct} OFF + free gifts',
    perks: ['FREE SHIPPING|on every order','NO CONTRACT|cancel anytime','{pct} OFF|every refill','NEVER RUN OUT|auto-delivery'],
    trust_label: 'EXCELLENT', trust_rating: '4.8', trust_text: 'rated 4.8/5 from 21,935 Reviews · 57M+ servings', trust_source: '',
    fbt_title: 'Frequently bought together:',
    fbt: []
  };
  var CFG = {};
  try { var cn = document.getElementById('pocd-config'); if (cn) CFG = JSON.parse(cn.textContent || '{}') || {}; } catch(e){ CFG = {}; }
  function cfg(k){ var v = CFG[k]; return (v === undefined || v === null || v === '') ? DEF[k] : v; }

  /* ---- sub-only free gifts ----
     Variant ids come from the section settings (#pocd-config "gifts"). The drawer is
     the ONLY writer of gift lines: the buybox adds the main line, every add/change
     re-renders here, and reconcile() makes the cart match the rule
       "probiotic on a selling plan in cart" <=> "each gift present once, $0, _gift prop".
     Blank ids = feature dormant. A failed gift write disarms reconcile for the page so a
     sold-out/unpublished gift can never loop or block the sale. */
  var GIFTS = (CFG.gifts || []).map(function(x){ return parseInt(x, 10); }).filter(function(x){ return x > 0; });
  window.__poGifts = GIFTS.slice();
  var giftsDisarmed = false, reconciling = false;
  function isGift(it){ return !!(it.properties && it.properties._gift); }

  var IC = {
    x:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    chev:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>',
    check:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>',
    star:'<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7z"/></svg>',
    checkc:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.5 2.5L16 9.5"/></svg>'
  };

  var bgEl, drawerEl, plans = {}, planPending = {}, lastCart = null;

  function money(c){ return '$' + (c/100).toFixed(2); }
  function pctLabel(p){ return Math.round(p) + '%'; }
  /* the one offer number the funnel advertises; falls back to the plan's own discount */
  function dispPct(planPct){ var o = cfg('strip_pct'); return (o && String(o).trim()) ? String(o).trim() : pctLabel(planPct); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function tpl(s, m){ return String(s).replace(/\{(\w+)\}/g, function(_, k){ return m[k] != null ? m[k] : ''; }); }

  function xhr(method, url, data, cb){
    var x = new XMLHttpRequest(), done=false;
    function fin(t){ if(done) return; done=true; cb && cb(t); }
    x.__pocdOwn = true;
    x.open(method, url, true);
    if (data) x.setRequestHeader('Content-Type','application/json');
    x.timeout = 8000;
    x.ontimeout = function(){ fin(null); };
    x.onreadystatechange = function(){ if(x.readyState===4) fin(x.responseText); };
    x.send(data ? JSON.stringify(data) : null);
  }

  /* ---- selling plan discovery (per product handle, cached) ---- */
  function planFor(it){
    var p = plans[it.handle];
    if (!p || !p.id) return null;
    var sub = p.byVariant[it.variant_id];
    if (sub == null) return null;
    return { id: p.id, name: p.name, pct: p.pct, subPrice: sub };
  }
  function discover(cart, cb){
    var need = {};
    (cart.items||[]).forEach(function(it){
      if (!it.selling_plan_allocation && !isGift(it) && it.handle && plans[it.handle] === undefined && !planPending[it.handle]) need[it.handle] = 1;
    });
    var handles = Object.keys(need);
    if (!handles.length){ cb(); return; }
    var left = handles.length;
    handles.forEach(function(h){
      planPending[h] = 1;
      xhr('GET', '/products/' + h + '.js', null, function(t){
        delete planPending[h];
        var rec = { id: null };
        try {
          var pj = JSON.parse(t);
          var g = (pj.selling_plan_groups||[])[0];
          var sp = g && (g.selling_plans||[])[0];
          if (sp){
            var adj = (sp.price_adjustments||[])[0];
            var pct = adj && adj.value_type === 'percentage' ? parseFloat(adj.value) : 0;
            var byVariant = {};
            (pj.variants||[]).forEach(function(v){
              var al = (v.selling_plan_allocations||[]).filter(function(a){ return a.selling_plan_id === sp.id; })[0];
              if (al) byVariant[v.id] = al.price;
              else if (pct) byVariant[v.id] = Math.round(v.price * (100 - pct)) / 100;
              if (!pct && al && v.price) pct = (v.price - al.price) / v.price * 100;
            });
            rec = { id: sp.id, name: sp.name || '', pct: pct, byVariant: byVariant };
          }
        } catch(e){}
        plans[h] = rec;
        if (--left === 0) cb();
      });
    });
  }

  /* ---- DOM ---- */
  function ensureDrawer(){
    if (drawerEl) return;
    bgEl = document.createElement('div'); bgEl.className='pocd__bg';
    drawerEl = document.createElement('div'); drawerEl.className='pocd'; drawerEl.setAttribute('role','dialog'); drawerEl.setAttribute('aria-modal','true'); drawerEl.setAttribute('aria-label','Cart'); drawerEl.setAttribute('tabindex','-1');
    drawerEl.innerHTML =
      '<div class="pocd__head"><span class="pocd__title">Your Cart</span><span class="pocd__count">0</span><button class="pocd__x" type="button" aria-label="Close">'+IC.x+'</button></div>'+
      '<div class="pocd__strip" hidden></div>'+
      '<div class="pocd__body" data-body></div>'+
      '<div data-fbt></div>'+
      '<div class="pocd__foot" data-foot></div>'+
      '<div class="pocd__spin"></div>';
    document.body.appendChild(bgEl); document.body.appendChild(drawerEl);
    bgEl.addEventListener('click', closeCart);
    drawerEl.querySelector('.pocd__x').addEventListener('click', closeCart);
    document.documentElement.setAttribute('data-pocd-on','');
    drawerEl.addEventListener('click', onAction);
    // keyboard: Escape closes, Tab stays inside the dialog while it is open
    document.addEventListener('keydown', function(e){
      if (!drawerEl.classList.contains('open')) return;
      if (e.key === 'Escape' || e.keyCode === 27){ e.preventDefault(); closeCart(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(drawerEl.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'), function(el){ return el.offsetWidth || el.offsetHeight; });
      if (!f.length) return;
      var first = f[0], last = f[f.length-1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === drawerEl)){ e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    });
  }
  var lastFocus = null;

  var accHolder = null;
  function accNode(){
    if (!accHolder){
      var src = document.getElementById('pocd-acc-src');
      accHolder = document.createElement('div'); accHolder.className = 'pocd__accwrap';
      if (src){ while (src.firstChild) accHolder.appendChild(src.firstChild); src.parentNode && src.parentNode.removeChild(src); }
    }
    return accHolder;
  }
  function mountAcc(){
    var slot = drawerEl.querySelector('[data-acc]');
    if (!slot) return;
    slot.appendChild(accNode());
    try { if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) Shopify.PaymentButton.init(); } catch(e){}
  }

  function killDawn(){
    ['cart-drawer','#CartDrawer'].forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(d){ d.classList.remove('active','animate','open'); });
    });
    ['overflow-hidden','overflow-hidden-mobile','overflow-hidden-tablet'].forEach(function(c){
      document.body.classList.remove(c); document.documentElement.classList.remove(c);
    });
  }
  function openDrawer(){ ensureDrawer(); killDawn(); document.body.style.overflow='hidden'; bgEl.classList.add('open');
    if (!drawerEl.classList.contains('open')) lastFocus = document.activeElement;
    requestAnimationFrame(function(){ drawerEl.classList.add('open'); });
    setTimeout(function(){ killDawn(); var x = drawerEl.querySelector('.pocd__x'); if (x && drawerEl.classList.contains('open') && !drawerEl.contains(document.activeElement)) x.focus({ preventScroll: true }); }, 120);
    setTimeout(killDawn, 450); }
  function closeCart(){ if(!drawerEl || !drawerEl.classList.contains('open')) return; drawerEl.classList.remove('open'); bgEl.classList.remove('open'); document.body.style.overflow=''; killDawn();
    var lf = lastFocus; lastFocus = null; if (lf && lf.focus && document.contains(lf)) { try { lf.focus({ preventScroll: true }); } catch(e){} } }

  /* ---- render ---- */
  function analyse(cart){
    var items = cart.items || [], eligible = [], subs = [], others = [], gifts = [];
    var maxPct = 0, subTotalIfAll = 0, oneTimeTotal = 0, saving = 0, subPct = 0;
    items.forEach(function(it){
      var spa = it.selling_plan_allocation;
      if (isGift(it)){ gifts.push(it); return; }
      if (spa){
        subs.push(it);
        subTotalIfAll += it.final_line_price;
        var cap = spa.compare_at_price || 0;
        oneTimeTotal += cap > spa.price ? cap * it.quantity : it.final_line_price;
        if (cap > spa.price){ saving += (cap - spa.price) * it.quantity; var pp = (cap - spa.price) / cap * 100; if (pp > subPct) subPct = pp; }
      } else {
        var pl = planFor(it);
        if (pl){ eligible.push(it); subTotalIfAll += pl.subPrice * it.quantity; if (pl.pct > maxPct) maxPct = pl.pct; }
        else { others.push(it); subTotalIfAll += it.final_line_price; }
        oneTimeTotal += it.final_line_price;
      }
    });
    var paidCount = 0; items.forEach(function(it){ if (!isGift(it)) paidCount += it.quantity; });
    return { items:items, eligible:eligible, subs:subs, others:others, gifts:gifts, paidCount:paidCount, maxPct:maxPct, subPct:subPct, subTotalIfAll:subTotalIfAll, oneTimeTotal:oneTimeTotal, saving:saving };
  }

  function giftRowHTML(it){
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x160$1$2') : '';
    return '<div class="pocd__ci is-gift" data-key="'+esc(it.key)+'">'+
      (img?'<img class="pocd__ci-img" src="'+esc(img)+'" alt="" loading="lazy">':'<div class="pocd__ci-img"></div>')+
      '<div class="pocd__ci-main"><p class="pocd__ci-name">'+esc(it.product_title)+'</p>'+
      '<p class="pocd__ci-sub">'+esc(cfg('gift_line'))+'</p>'+
      '<div class="pocd__ci-pricerow">'+(it.original_line_price > 0 ? '<span class="pocd__ci-was">'+money(it.original_line_price)+'</span>' : '')+'<span class="pocd__ci-price is-free">FREE</span></div>'+
      '</div><div class="pocd__ci-side"><span class="pocd__ci-gifttag">'+IC.check+'GIFT</span></div></div>';
  }
  function rowHTML(it){
    if (isGift(it)) return giftRowHTML(it);
    var spa = it.selling_plan_allocation;
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x160$1$2') : '';
    var sub, elig = '', was = '', off = '';
    if (spa){
      var freq = (spa.selling_plan && spa.selling_plan.name || '').replace(/^delivery\s+/i,'').toLowerCase();
      sub = tpl(cfg('sub_line_sub'), { freq: esc(freq || 'recurring') });
      var cap = spa.compare_at_price || 0;
      if (cap > spa.price){ was = '<span class="pocd__ci-was">'+money(cap * it.quantity)+'</span>'; off = '<span class="pocd__ci-off">'+money((cap - spa.price) * it.quantity)+' off</span>'; }
    } else {
      sub = cfg('sub_line_one');
      var pl = planFor(it);
      if (pl) elig = '<button class="pocd__ci-sub" type="button" data-sub-line>'+IC.check+'<span>'+tpl(cfg('line_switch'), {pct: dispPct(pl.pct), price: money(pl.subPrice * it.quantity)})+'</span></button>';
      if (it.original_line_price > it.final_line_price) was = '<span class="pocd__ci-was">'+money(it.original_line_price)+'</span>';
    }
    return '<div class="pocd__ci" data-key="'+esc(it.key)+'">'+
      (img?'<img class="pocd__ci-img" src="'+esc(img)+'" alt="" loading="lazy">':'<div class="pocd__ci-img"></div>')+
      '<div class="pocd__ci-main"><p class="pocd__ci-name">'+esc(it.product_title)+'</p>'+
      '<p class="pocd__ci-sub">'+sub+'</p>'+
      '<div class="pocd__ci-pricerow">'+(spa ? was : '')+'<span class="pocd__ci-price">'+money(it.final_line_price)+'</span>'+(spa ? off : was)+'</div>'+
      elig+'</div>'+
      '<div class="pocd__ci-side"><span class="pocd__qty"><button type="button" data-dec aria-label="Decrease">&minus;</button><span>'+it.quantity+'</span><button type="button" data-inc aria-label="Increase">+</button></span>'+
      '<button class="pocd__ci-del" type="button" data-del>Remove</button></div></div>';
  }

  function fbtHTML(cart){
    var list = cfg('fbt') || [];
    var inCart = {};
    (cart.items||[]).forEach(function(it){ inCart[it.variant_id] = 1; });
    var cards = list.filter(function(p){ return p && p.variant_id && p.available !== false && p.price > 0 && !inCart[p.variant_id]; });
    if (!cards.length) return '';
    var html = '<div class="pocd__fbt"><p class="pocd__fbt-title">'+esc(cfg('fbt_title'))+'</p><div class="pocd__fbt-rail">';
    cards.forEach(function(p){
      html += '<div class="pocd__fbt-card">'+
        (p.image?'<img class="pocd__fbt-img" src="'+esc(p.image)+'" alt="" loading="lazy">':'<div class="pocd__fbt-img"></div>')+
        '<div class="pocd__fbt-main"><p class="pocd__fbt-name">'+esc(p.title)+'</p><p class="pocd__fbt-sub">'+esc(p.sub || 'One-time add-on')+'</p><p class="pocd__fbt-price">'+money(p.price)+'</p></div>'+
        '<button class="pocd__fbt-add" type="button" data-fbt-add="'+esc(p.variant_id)+'">Add +</button></div>';
    });
    html += '</div>';
    if (cards.length > 1){ html += '<div class="pocd__fbt-dots">'; cards.forEach(function(_, i){ html += '<i'+(i?'':' class="on"')+'></i>'; }); html += '</div>'; }
    return html + '</div>';
  }

  function perksHTML(pct){
    var perks = cfg('perks') || [];
    var h = '<div class="pocd__perks">';
    perks.forEach(function(p){
      if (!p) return;
      var parts = String(p).split('|');
      var b = tpl(parts[0], {pct: pct}), r = tpl(parts.slice(1).join('|'), {pct: pct});
      h += '<span class="pocd__perk">'+IC.check+'<span><b>'+esc(b)+'</b>'+(r?' '+esc(r):'')+'</span></span>';
    });
    return h + '</div>';
  }
  function trustHTML(){
    var rating = parseFloat(cfg('trust_rating')) || 5, stars = '';
    for (var i=0;i<5;i++) stars += '<span class="'+(i < Math.round(rating) ? 'on' : '')+'">'+IC.star+'</span>';
    var src = cfg('trust_source') ? ' <b class="pocd__src">'+esc(cfg('trust_source'))+'</b>' : '';
    return '<div class="pocd__trust"><b>"'+esc(cfg('trust_label'))+'"</b><span class="pocd__stars">'+stars+'</span><span>'+esc(cfg('trust_text'))+src+'</span></div>';
  }
  function btn(tag, cls, extra, label, price){
    return '<'+tag+' class="'+cls+'" '+extra+'><span class="lbl">'+label+'</span><span class="prc">'+money(price)+'</span>'+IC.chev+'</'+tag+'>';
  }

  function footHTML(cart, a){
    if (!a.items.length) return '';
    var total = cart.total_price;
    var orig = a.subs.length && !a.eligible.length ? a.oneTimeTotal : cart.original_total_price;
    var n = a.paidCount;
    var h = '<div class="pocd__totrow"><span class="pocd__totlbl">Subtotal: '+n+' '+(n === 1 ? 'item' : 'items')+'</span><span class="pocd__totright">';
    if (orig > total){ h += '<span class="pocd__was">'+money(orig)+'</span>'; }
    h += '<span class="pocd__tot">'+money(total)+'</span>';
    if (orig > total){ h += '<span class="pocd__off">'+money(orig-total)+' OFF</span>'; }
    h += '</span></div>';
    var pct = dispPct(a.maxPct);
    if (a.eligible.length){
      h += '<div class="pocd__tagwrap"><span class="pocd__tag">'+tpl(cfg('tag'), {pct: pct})+'</span></div>';
      h += btn('button', 'pocd__primary', 'type="button" data-sub-all', cfg('primary_sub'), a.subTotalIfAll);
      h += perksHTML(pctLabel(a.maxPct));
      h += btn('a', 'pocd__secondary', 'href="/checkout"', cfg('secondary'), total);
    } else if (a.subs.length){
      h += '<a class="pocd__primary is-center" href="/checkout"><span class="lbl">'+cfg('primary_co')+'</span>'+IC.chev+'</a>';
      h += '<div class="pocd__guarantee"><span>'+IC.checkc+esc(cfg('guarantee'))+'</span></div>';
      h += '<button class="pocd__switch" type="button" data-one-all>'+tpl(cfg('switch_'), {price: money(a.oneTimeTotal)})+'</button>';
    } else {
      h += '<a class="pocd__primary is-center is-plum" href="/checkout"><span class="lbl">'+cfg('primary_co')+'</span>'+IC.chev+'</a>';
    }
    h += '<div class="pocd__acc" data-acc></div>' + trustHTML();
    return h;
  }

  function syncHeader(n){
    var a = document.getElementById('cart-icon-bubble'); if (!a) return;
    var b = a.querySelector('.cart-count-bubble');
    if (!n){ if (b) b.parentNode.removeChild(b); return; }
    if (!b){ b = document.createElement('div'); b.className = 'cart-count-bubble'; a.appendChild(b); }
    b.innerHTML = (n < 100 ? '<span aria-hidden="true">'+n+'</span>' : '') + '<span class="visually-hidden">'+n+' '+(n === 1 ? 'item' : 'items')+'</span>';
  }
  function renderCart(cart){
    ensureDrawer();
    lastCart = cart;
    var a = analyse(cart);
    drawerEl.querySelector('.pocd__count').textContent = a.paidCount;
    syncHeader(a.paidCount);
    var strip = drawerEl.querySelector('.pocd__strip');
    if (a.eligible.length){ strip.innerHTML = tpl(cfg('strip_upsell'), {pct: dispPct(a.maxPct)}); strip.hidden = false; }
    else if (a.subs.length){ strip.innerHTML = tpl(cfg('strip_saving'), {amt: money(a.saving), pct: dispPct(a.subPct)}); strip.hidden = false; }
    else strip.hidden = true;
    var body = drawerEl.querySelector('[data-body]');
    var ordered = a.items.filter(function(it){ return !isGift(it); }).concat(a.gifts);
    body.innerHTML = a.items.length ? ordered.map(rowHTML).join('') : '<div class="pocd__empty">Your cart is empty</div>';
    drawerEl.querySelector('[data-fbt]').innerHTML = a.items.length ? fbtHTML(cart) : '';
    drawerEl.querySelector('[data-foot]').innerHTML = footHTML(cart, a);
    if (a.items.length) mountAcc();
    var rail = drawerEl.querySelector('.pocd__fbt-rail');
    if (rail) rail.addEventListener('scroll', function(){ var i = Math.round(rail.scrollLeft / (rail.firstElementChild.offsetWidth + 12)); drawerEl.querySelectorAll('.pocd__fbt-dots i').forEach(function(d, j){ d.classList.toggle('on', j===i); }); }, {passive:true});
  }

  function giftPlan(a){
    var want = a.subs.length && GIFTS.length ? GIFTS : [];
    var adds = [], removes = [], fixes = [];
    var have = {};
    a.gifts.forEach(function(it){
      var slot = parseInt(it.properties._gift, 10);
      var ok = want.length && slot >= 1 && slot <= want.length && want[slot-1] === it.variant_id && !have[slot];
      if (!ok){ removes.push(it); return; }
      have[slot] = it;
      if (it.quantity !== 1) fixes.push(it);
    });
    want.forEach(function(id, i){ if (!have[i+1]) adds.push({ id: id, quantity: 1, properties: { _gift: String(i+1) } }); });
    return { adds: adds, removes: removes, fixes: fixes };
  }
  function reconcile(cart, cb){
    var a = analyse(cart), plan = giftPlan(a);
    if (giftsDisarmed || reconciling || (!plan.adds.length && !plan.removes.length && !plan.fixes.length)){ cb(false); return; }
    reconciling = true;
    var steps = [];
    plan.removes.forEach(function(it){ steps.push(function(next){ changeLine(it.key, 0, undefined, function(t){ next(!!t); }); }); });
    plan.fixes.forEach(function(it){ steps.push(function(next){ changeLine(it.key, 1, undefined, function(t){ next(!!t); }); }); });
    if (plan.adds.length) steps.push(function(next){ xhr('POST','/cart/add.js', { items: plan.adds }, function(t){ var ok = false; try { ok = !!(JSON.parse(t).items); } catch(e){} next(ok); }); });
    (function run(i){
      if (i >= steps.length){ reconciling = false; cb(true); return; }
      steps[i](function(ok){ if (!ok){ giftsDisarmed = true; reconciling = false; cb(true); return; } run(i+1); });
    })(0);
  }
  function render(cart, cb){
    discover(cart, function(){
      renderCart(cart);
      reconcile(cart, function(changed){
        if (!changed){ cb && cb(); return; }
        xhr('GET','/cart.js',null,function(t){ var c=null; try{ c = JSON.parse(t); }catch(e){} if (c && c.items) renderCart(c); cb && cb(); });
      });
    });
  }

  /* ---- actions ---- */
  function busy(on){ if (!drawerEl) return; drawerEl.classList.toggle('loading', !!on); }
  var wd;
  function guard(){ clearTimeout(wd); busy(true); wd = setTimeout(function(){ busy(false); }, 9000); }
  function finish(t){ clearTimeout(wd); var done = function(){ busy(false); document.dispatchEvent(new CustomEvent('pocd:changed')); };
    try { var c = JSON.parse(t); if (c && c.items) render(c, done); else refresh(done); } catch(e){ refresh(done); } }

  function changeLine(key, q, plan, cb){
    var body = { id: key, quantity: q };
    if (plan !== undefined) body.selling_plan = plan;
    xhr('POST','/cart/change.js', body, cb);
  }
  function changeQty(key, q){ guard(); changeLine(key, q, undefined, finish); }

  // convert lines one at a time: each change rewrites that line's key, others stay valid
  function convertAll(list, planOf){
    guard();
    var i = 0, last = null;
    (function next(){
      if (i >= list.length){ finish(last); return; }
      var it = list[i++];
      changeLine(it.key, it.quantity, planOf(it), function(t){ last = t; next(); });
    })();
  }
  function fbtAdd(vid){
    guard();
    xhr('POST','/cart/add.js', { items:[{ id: Number(vid), quantity: 1 }] }, function(){ clearTimeout(wd); refresh(function(){ busy(false); document.dispatchEvent(new CustomEvent('pocd:changed')); }); });
  }

  function onAction(e){
    var t = e.target.closest ? e.target : null; if (!t) return;
    var row = t.closest('.pocd__ci'), key = row && row.getAttribute('data-key');
    if (t.closest('[data-inc]') && key){ changeQty(key, qtyOf(row)+1); return; }
    if (t.closest('[data-dec]') && key){ changeQty(key, qtyOf(row)-1); return; }
    if (t.closest('[data-del]') && key){ changeQty(key, 0); return; }
    if (t.closest('[data-sub-line]') && key && lastCart){
      var one = (lastCart.items||[]).filter(function(it){ return it.key === key && planFor(it); });
      if (one.length) convertAll(one, function(it){ return planFor(it).id; });
      return;
    }
    if (t.closest('[data-sub-all]') && lastCart){ var a = analyse(lastCart); convertAll(a.eligible, function(it){ return planFor(it).id; }); return; }
    if (t.closest('[data-one-all]') && lastCart){ var b = analyse(lastCart); convertAll(b.subs, function(){ return null; }); return; }
    var add = t.closest('[data-fbt-add]'); if (add){ fbtAdd(add.getAttribute('data-fbt-add')); return; }
  }
  function qtyOf(row){ return parseInt(row.querySelector('.pocd__qty span').textContent, 10) || 0; }

  var refreshQ = null;
  function refresh(cb){
    if (refreshQ){ refreshQ.push(cb); return; }
    refreshQ = [cb];
    xhr('GET','/cart.js',null,function(t){
      var q = refreshQ; refreshQ = null;
      var fire = function(){ q.forEach(function(f){ f && f(); }); };
      var c=null; try{ c = JSON.parse(t); }catch(e){}
      if (c && c.items) render(c, fire); else fire();
    });
  }

  function showCart(){ ensureDrawer(); openDrawer(); guard();
    refresh(function(){ clearTimeout(wd); busy(false); }); }

  window.openCart = showCart;
  window.__poCartDrawer = { open: showCart, close: closeCart, refresh: refresh };

  /* ---- hook every add flow so the drawer opens ---- */
  function hookAdd(){
    if (window.fetch && !window.fetch.__pocd){
      var of = window.fetch.bind(window);
      var wrapped = function(){
        var a0 = arguments[0];
        var url = (a0 && typeof a0 === 'object' && a0.url) ? a0.url : a0;
        var p = of.apply(null, arguments);
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)){
          p.then(function(){ setTimeout(showCart, 30); }).catch(function(){});
        }
        return p;
      };
      wrapped.__pocd = true;
      window.fetch = wrapped;
    }
    var ox = XMLHttpRequest.prototype.open;
    if (!ox.__pocd){
      XMLHttpRequest.prototype.open = function(m,u){ this.__pocdUrl=u; return ox.apply(this, arguments); };
      XMLHttpRequest.prototype.open.__pocd = true;
      var os = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function(){
        var self=this;
        if (!self.__pocdOwn && typeof self.__pocdUrl==='string' && /\/cart\/(add)/.test(self.__pocdUrl)){
          self.addEventListener('load', function(){ setTimeout(showCart, 30); });
        }
        return os.apply(this, arguments);
      };
    }
  }

  function bind(){
    ensureDrawer();
    hookAdd();
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('#cart-icon-bubble, a[href$="/cart"], a[href*="/cart?"]');
      if (a){ e.preventDefault(); showCart(); }
    }, true);
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
